<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          :lead="leader"
          style="background-color: rgba(0, 0, 0, 0);width:80%"
        />
      </div>
    </div>
    <div class="stickybar">
      <a :style="partI===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">业务挑战</a>
      <a :style="partII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">解决方案</a>
      <a :style="partIII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">解决方案优势</a>
      <a :style="partIV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">成功故事</a>
      <!-- <a :style="partV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(5)">相关产品</a> -->
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text contenttext">
          <h3>业务挑战</h3>
        </div>
        <introduceCard :arr="cardarr" style="padding-bottom:90px" />
      </div>
    </div>
    <div
      id="parttwo"
      ref="partii"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0;background:url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202009/24162258bvi6.png') no-repeat"
    >
      <div class="title">
        <p class="contenttext" style="color:white;text-align:center">
          <br >我家云智慧物业解决方案
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr2" :key="index" :class="{hoverChange:nowindex2 === index}" class="introducecard2" @mouseenter="mouseOver2(index)" @mouseleave="mouseLeave2(index)">
            <div :style="nowindex2===index ? 'overflow:visible;color:white':'overflow:hidden;color:white'" class="introduceText animation">
              <div class="card-title2"><h4>{{ item.title }}</h4></div>
              <div class="card-text2">{{ item.content }}</div>
              <div v-if="nowindex2===index" class="introduceButton2">
                <router-link class="experience-link" to="/aboutUs">详情咨询</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="partthree"
      ref="partiii"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >解决方案优势
        </p>
        <introduceCard3 :arr="cardarr2" style="padding-bottom:90px" />
        <!-- <div class="introducecard-frame">
          <div v-for="(item,index) in arr3" :key="index" class="introducecard2" style="height:364px">
            <div class="image3">
              <img src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/1118203743vj.png" alt="">
            </div>
            <div :class="{hoverChange2:nowindex3 === index}" class="introduceText3" @mouseenter="mouseOver3(index)" @mouseleave="mouseLeave3(index)">
              <div class="card-title3"><h4>{{ item.title }}</h4></div>
              <div class="card-text3">{{ item.content }}</div>
              <a v-if= "nowindex3 === index">
                <div class="mybtn" >案例详情</div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div
      id="partfour"
      ref="partiv"
      class="review"
      style="background: rgba(234,239,243,1); margin-left: 0; margin-right: 0;padding-bottom: 60px;"
    >
      <div class="title">
        <card :arr3="arr3" />
      </div>
    </div>
    <!-- <div
      id="partfive"
      ref="partv"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >相关产品
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr" :key="index" :class="{hoverChange:nowindex === index}" class="introducecard" @mouseenter="mouseOver(index)" @mouseleave="mouseLeave(index)">
            <div v-if="nowindex !== index" class="introduceImage">
              <img :src="item.link" alt="">
            </div>
            <div class="introduceText">
              <div class="card-title"><h4>{{ item.title }}</h4></div>
              <div class="card-text">{{ item.content }}</div>
              <div :style="nowindex===index ? {'opacity':1,'marginTop':'40%'} :'opacity:0'" class="introduceButton">
                <a class="experience-link" href="/access">免费体验</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import introduceCard3 from '@/components/introducecard3'
import introduceCard from '@/components/introducecard2'
import Card from '@/components/introducecard'
export default {
  name: 'Medic',
  components: { introduceCard, Card, introduceCard3 },
  data() {
    return {
      header: '智慧物业解决方案',
      leader: '构建物业产业互联平台',
      cardarr: [
        { title: '无决策支撑', content: '', link: '	https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14224743hg5j.png' },
        { title: '运营不统一，成本高', content: '', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14224812o88t.png' },
        { title: '管理不统一，效率低', content: '', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14224838ca26.png' },
        { title: '系统孤岛、多业态管理难', content: '', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14224928hz7h.png' }
      ],
      cardarr2: [
        { title: '新平台', content: '在线租赁模式，免硬件网络设备、免专业IT人员，系统上线快，极大地降低物业企业向数字化转型的投入。', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14232645j6mt.png' },
        { title: '新技术', content: '通过智能设备大幅提升管理效率，降本增效。通过移动互联网、云计算技术的应用，扩大物业企业管理半径。', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14234010smz6.png' },
        { title: '新服务', content: '以业主为中心，业主通过微信公众号或APP连接物业智能生活。数字化社区生活环境，提升业主的幸福生活指数。', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/142340383zej.png' },
        { title: '新生态', content: '整合线上线下资源，进行商业模式创新，通过社区增值服务不断为企业创造新的盈利点，获取高额增值回报。', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14224928hz7h.png' }
      ],
      arr2: [
        { title: '数据分析', content: '集团化管控，整合区域项目经营指标数据进行统计分析，观测数据变动异常，提前预防经营风险，支撑集团战略落地' },
        { title: '增值服务', content: '链接周边商业资源及内部住户资源，形成新的商业链，为住户提供更多的服务配套资源，为企业整合闲置资源，使资源变现，实现企业的增值创收' },
        { title: '物联集成', content: '整合智能系统资源，拉通系统间的联动，打破信息孤岛，实现企业集团化集约管控。联合第三方平台、软件等系统，信息互通，实现产业生态化' },
        { title: '统一收费', content: '满足市场各种收费方式，为客户开放多种缴费渠道，提升企业收缴率，在统一平台收取各类费用，减少不同系统间对账核账问题，提升财务工作效率' },
        { title: '物业服务', content: '在统一平台实现实现物业的服务与管理，对服务门户的统一管理，内部管理与外部服务形成一个闭环，及时响应客户服务诉求，提升客户满意度' }
      ],
      arr3: [
        { title: '龙光物业', content: '', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12115031bhnx.png' },
        { title: '天骄爱生活：科技赋能，助力商住产一体化发展', content: '', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12114926ph4s.png' }
      ],
      nowindex: '',
      nowindex2: '',
      nowindex3: '',
      nowindex4: 0,
      nowIndex: [0],
      partI: false,
      partII: false,
      partIII: false,
      partIV: false
      // partV: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollLisenter)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollLisenter)
  },
  methods: {
    jump: function(x) {
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      if (x === 5) {
        x = '#partfive'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    scrollLisenter: function() {
      var length = document.documentElement.scrollTop + 37
      if (length >= 0 && length < this.$refs.partii.offsetTop) {
        this.partI = true
      } else this.partI = false
      if (length > this.$refs.partii.offsetTop && length < this.$refs.partiii.offsetTop) {
        this.partII = true
      } else this.partII = false
      if (length > this.$refs.partiii.offsetTop && length < this.$refs.partiv.offsetTop) {
        this.partIII = true
      } else this.partIII = false
      // if (length > this.$refs.partiv.offsetTop && length < this.$refs.partv.offsetTop) {
      //   this.partIV = true
      // } else this.partIV = false
      if (length > this.$refs.partiv.offsetTop) {
        this.partIV = true
      } else this.partIV = false
    },
    mouseOver: function(x) {
      this.nowindex = x
    },
    mouseLeave: function(x) {
      this.nowindex = -1
    },
    mouseOver2: function(x) {
      this.nowindex2 = x
    },
    mouseLeave2: function(x) {
      this.nowindex2 = -1
    },
    mouseOver3: function(x) {
      this.nowindex3 = x
    },
    mouseLeave3: function(x) {
      this.nowindex3 = -1
    },
    mouseOver4: function(x) {
      this.nowindex4 = x
    },
    mouseLeave4: function(x) {
      this.nowindex4 = x
    },

    mouseOvers: function(type, index) {
      this.nowIndex[type] = index
    },
    mouseLeaves: function(type, index) {
      this.nowIndex[type] = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/201724409o08.png') no-repeat;
  background-size: 100% 100%;
  height: 100%;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.titletext {
  font-size: 50px;
  font-family: "Permanent Marker", cursive;
  color: rgb(22, 21, 21);
}

.contenttext {
  color: rgb(0, 0, 0);
  font-size: 32px;
  /* font-family: Georgia, "Times New Roman", Times, serif; */
  text-align: center;
  padding: 6%;
  padding-top: 4%;
  margin:0;
}

.top-text {
  padding: 50px 0 50px 0;
}

.card {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.introducecard-frame{
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.introducecard {
  background-color: rgba(236, 234, 227, 0.39);
  width:293px;
  height:315px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 3px;
  position: relative;
}

.introducecard2 {
  /* background-color: rgba(243, 241, 235, 0.473); */
  /* background-color:rgba(247,247,247,1); */
  background: rgba(35,133,237,0.2);
  height:264px;
  width:584px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin:0px 8px 20px 8px;
}

.introduceImage {
  padding-top: 50px;
}

.introduceText {
  padding: 20px 30px 30px 30px;
}

.introduceButton {
  border:1px solid rgba(255,255,255,1);
  background-color: rgba(59, 124, 209, 0.39);
  opacity: 0;
  width:100px;
  margin: auto;
  ;
}

.introduceButton2 {
  border:1px solid rgba(255,255,255,1);
  bottom: 75px;
  background-color: rgba(0, 203, 253, 1);
  width:100px;
  margin: auto;
}

.introduceButton a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.introduceButton2 a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.hoverChange {
  background-color: rgba(20, 130, 238, 1);
  transition: 0.4s;
  color:white;
  box-shadow: 0px 0px 5px #000;
}

.animation {
  position: relative;
  transition: all 0.4s;
}

.animation:hover {
  transition: transform 0.4s;
  transform: translateY(-40px);
}

.card-title2 {
  margin-top: 10%;
  text-align: left;
}

.card-title3 {
  margin-top: 1%;
  text-align: left;
}

.card-text2 {
  word-break:hyphenate;
  font-size: 14px;
  padding-top: 2%;
  padding-bottom: 2%;
  text-align: left;
  height:120px;
}

.card-text3 {
  font-size: 14px;
  text-align: left;
}

.introduceText3 {
  background-color: rgb(255, 255, 255);
  position: absolute;
  bottom:0;
  transition: all 0.4s;
  height: 140px;
  padding:4%;
}

.introduceText3:hover {
  height: 200px;
  transition:0.4s;
}

.introducecard2 img {
  width:100%;
}

.mybtn {
  width:25%;
  background-color: rgb(62, 88, 112);
  margin: 30px auto;
  padding: 1%;
  color: white;
}

.leftMenu {
  display: flex;
  flex-direction: column;
  width: 150px;
  text-align: left;
  padding: 10% 0%;
  box-shadow: -20px 0px 20px -10px rgb(0 0 0 / 4%) inset;
}

.leftMenu-item {
  padding:18% 10% 18% 10%;
  position: relative;
}

.rightContent {
  width: 100%;
  background-color: rgba(128, 126, 126, 0.075);
  padding:10%;
}

.hoverItem {
  background-color: rgba(45,139,238,1);
  color: ivory;
  width:140%;
  font-size: 20px;
}

.big-title {
  margin: auto;
  padding:5%;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}

.stickybar a{
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/solutions/components/property.vue